<template lang="pug">
.edi-template
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h2.primary--text {{ $t('ScheduleAction.trigger') }}
    v-row
      v-col(cols="6")
        v-select(
          :label="$t('ScheduleAction.trigger')",
          :items="triggers",
          item-text="name",
          item-value="id",
          :loading="triggersLoading",
          v-model="instance.triggerId"
        )
    v-row  
      v-col.d-flex.align-center
        h2.primary--text {{ $t('ScheduleAction.scheduleAnAction') }}
    v-row
      v-col(cols="6")
        v-text-field(
          :label="$t('ScheduleAction.expression')"
          v-model="instance.body",
          v-show="!instance.recurrenceOptions.isRecurrence"
        )
    v-row  
      v-col(cols="6")
        v-switch(
          v-model="instance.recurrenceOptions.isRecurrence",
          :label="$t('ScheduleAction.recurrence')"
        )
    template(v-if="instance.recurrenceOptions.isRecurrence")
      v-row
        v-col(cols="1")
          v-text-field(
            :label="$t('ScheduleAction.repeat')",
            v-model="instance.recurrenceOptions.every",
            type="number",
            controls,
            class="repeat-every-field",
          )
        v-col(cols="6")
          v-select(
            :label="$t('ScheduleAction.unitTime')",
            :items="timeUnits",
            item-text="name",
            item-value="id",
            v-model="instance.recurrenceOptions.repeat",
            class="time-units-select"
          )
      v-row
        v-col(cols="6")
          v-text-field(
            :label="$t('ScheduleAction.startDate')",
            v-model="instance.body"
          )
      v-chip-group(v-model="instance.recurrenceOptions.executionDays", multiple)
        v-chip(
          v-for="day in weekDays",
          :key="day",
          :value="day",
          class="mr-2 v-chip v-chip--clickable theme--light v-size--default relation--chip custom-chip"
        ) {{ day }}
      v-row
        v-col(cols="6")
          v-text-field(
            :label="$t('ScheduleAction.endDate')",
            v-model="instance.recurrenceOptions.endDate"
          )
  </template>
  
<style type="text/css">
.custom-select {
  width: 632px;
  height: 19px;
}

span.text-size {
  overflow: hidden;
}

.custom-chip {
  background-color: rgba(50, 0, 230, 0.05);
  border-color: rgba(50, 0, 230, 0.05);
  font-size: 9px;
  font-weight: 700;
  font-family: "Avenir LT";
}

.custom-chip.v-chip--active,
.custom-chip.v-chip--active .v-chip__content {
  color: #3200E6;
}

.repeat-every-field {
  width: 70px;
  text-align: center;
}

.time-units-select {
  width: 161px;
}
</style>
  
<script>
import axios from 'axios';

export default {
  props: ['value'],
  data: function () {
    return {
      initObject: {
        type: 'Schedule Action',
        body: '',
        isRazor: true,
        triggerId: null,
        entityId: '@Model.Id',
        itemExternalId: '@Model.ExternalId',
        businessScopeId: '@Model.BusinessScope?.Id',
        recurrenceOptions: {}
      },
      timeUnits: ['Minute', 'Hour', 'Day', 'Week'],
      weekDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      instance: {},
      triggers: [],
      triggersLoading: true,
      newSelectItems: []
    }
  },
  computed: {
    schema() {
      return this.$store.state.schema.all;
    },
  },
  watch: {
    instance: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    async loadTriggers() {
      try {
        this.triggers = (await axios.get('Trigger', { params: { pageSize: -1 } })).data.data;
      } catch (e) {
        console.log(this.$cleanString(e))
      } finally {
        this.triggersLoading = false;
      }
    }
  },
  async created() {
    this.instance = { ...this.initObject, ...this.value };
    await this.loadTriggers();
  },
}
</script>
  